import vehiclesExamplesAnyBrandFR from '../config/vehiclesExamplesAnyBrand_fr.json';
import vehiclesExamplesAnyBrandGB from '../config/vehiclesExamplesAnyBrand_gb.json';
import vehiclesExamplesAnyBrandNL from '../config/vehiclesExamplesAnyBrand_nl.json';
import vehiclesExamplesManufacturerAT from '../config/vehiclesExamplesManufacturer_at.json';
import vehiclesExamplesManufacturerBE from '../config/vehiclesExamplesManufacturer_be.json';
import vehiclesExamplesManufacturerLU from '../config/vehiclesExamplesManufacturer_lu.json';
import vehiclesExamplesManufacturerDE from '../config/vehiclesExamplesManufacturer_de.json';
import vehiclesExamplesManufacturerFR from '../config/vehiclesExamplesManufacturer_fr.json';
import vehiclesExamplesManufacturerES from '../config/vehiclesExamplesManufacturer_es.json';
import vehiclesExamplesManufacturerGB from '../config/vehiclesExamplesManufacturer_gb.json';
import vehiclesExamplesManufacturerIT from '../config/vehiclesExamplesManufacturer_it.json';
import vehiclesExamplesManufacturerNL from '../config/vehiclesExamplesManufacturer_nl.json';
import vehiclesExamplesManufacturerPL from '../config/vehiclesExamplesManufacturer_pl.json';


export function retrieveVehicleExamples(context, settings) {
    if (settings.vehDescType === 'MANUFACTURER') {
        switch (context.countryCode) {
            case "AT":
                return getVehicleExamples(context, vehiclesExamplesManufacturerAT);
            case "BE":
                return getVehicleExamples(context, vehiclesExamplesManufacturerBE);
            case "LU":
                return getVehicleExamples(context, vehiclesExamplesManufacturerLU);
            case "DE":
                return getVehicleExamples(context, vehiclesExamplesManufacturerDE);
            case "FR":
                return getVehicleExamples(context, vehiclesExamplesManufacturerFR);
            case "ES":
                return getVehicleExamples(context, vehiclesExamplesManufacturerES);
            case "GB":
                return getVehicleExamples(context, vehiclesExamplesManufacturerGB);
            case "IT":
                return getVehicleExamples(context, vehiclesExamplesManufacturerIT);
            case "NL":
                return getVehicleExamples(context, vehiclesExamplesManufacturerNL);
            case "PL":
                return getVehicleExamples(context, vehiclesExamplesManufacturerPL);
            default:
                return {};
        }
    } else if (settings.vehDescType === 'ANYBRAND') {
        switch (context.countryCode) {
            case "FR":
                return getVehicleExamples(context, vehiclesExamplesAnyBrandFR);
            case "GB":
                return getVehicleExamples(context, vehiclesExamplesAnyBrandGB);
            case "NL":
                return getVehicleExamples(context, vehiclesExamplesAnyBrandNL);
            default:
                return {};
        }
    }
    return {};
}

function getVehicleExamples(context, data) {
    const dataDistributionBrand = data[context.distributionBrand];
    if (dataDistributionBrand == null) {
        return {};
    }
    if (dataDistributionBrand['journeyTypes'] != null && dataDistributionBrand['journeyTypes'][context.journeyType] != null) {
        return dataDistributionBrand['journeyTypes'][context.journeyType];
    }
    return { vehicles: dataDistributionBrand['vehicles'] };
}
